window.themeLog = window.themeLog || function () {};
/**
 * Header JavaScript - Performance Optimized
 * All header functionality consolidated for better performance
 */

// ==================================================
// CART ICON UPDATES
// ==================================================
document.addEventListener('DOMContentLoaded', function() {
  // Update cart icon when items are added
  document.addEventListener('cart:updated', function(event) {
    const cartCount = event.detail?.item_count || 0;
    updateCartIcon(cartCount);
  });

  // Update cart icon function
  function updateCartIcon(count) {
    const cartButtons = document.querySelectorAll('.action-btn[data-cart-count]');

    cartButtons.forEach(btn => {
      // Trigger animation by temporarily removing and re-adding data attribute
      btn.removeAttribute('data-cart-count');
      setTimeout(() => {
        btn.setAttribute('data-cart-count', count);
      }, 10);

      // Update badge
      const badge = btn.querySelector('.cart-badge');
      if (count > 0) {
        if (badge) {
          badge.textContent = count;
          badge.style.display = 'flex';
        } else {
          const newBadge = document.createElement('span');
          newBadge.className = 'cart-badge';
          newBadge.textContent = count;
          newBadge.style.display = 'flex';
          btn.appendChild(newBadge);
        }
      } else if (badge) {
        badge.remove();
      }

      // Update aria-label
      const itemText = count === 1 ? 'item' : 'items';
      btn.setAttribute('aria-label', `Winkelwagen, ${count} ${itemText}`);
    });
  }

  // Fetch current cart count on page load
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateCartIcon(cart.item_count);
    })
    .catch(error => console.error('Error fetching cart:', error));

  // ==================================================
  // MOBILE NAV SUBMENU FUNCTIONALITY
  // ==================================================

  // Open submenu when clicking parent nav item (level 2 and level 3)
  document.querySelectorAll('[data-submenu-trigger]').forEach(trigger => {
    trigger.addEventListener('click', function() {
      const submenuId = this.dataset.submenuTrigger;
      const submenu = document.querySelector(`[data-submenu="${submenuId}"]`);
      if (submenu) {
        submenu.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  // Close level 2 submenu when clicking back button
  document.querySelectorAll('[data-submenu-back]').forEach(backBtn => {
    backBtn.addEventListener('click', function() {
      const submenu = this.closest('.mobile-nav-submenu');
      if (submenu) {
        submenu.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });

  // Close level 3 submenu when clicking back button
  document.querySelectorAll('[data-submenu-back-level3]').forEach(backBtn => {
    backBtn.addEventListener('click', function() {
      const submenu = this.closest('.mobile-nav-submenu-level3');
      if (submenu) {
        submenu.classList.remove('active');
        // Don't restore body overflow as we're still in level 2
      }
    });
  });

  // Close all submenus on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.mobile-nav-submenu.active').forEach(submenu => {
        submenu.classList.remove('active');
      });
      document.body.style.overflow = '';
    }
  });

  // Mobile login panel trigger
  const mobileLoginTrigger = document.getElementById('login-panel-trigger-mobile');
  if (mobileLoginTrigger) {
    mobileLoginTrigger.addEventListener('click', function() {
      // Trigger the same login panel as desktop
      document.getElementById('login-panel-trigger')?.click();
    });
  }

  // ==================================================
  // MOBILE SEARCH DRAWER
  // ==================================================

  // Mobile search drawer - auto-focus input when opened
  const mobileSearchToggle = document.getElementById('mobile-search-toggle');
  const mobileSearchInput = document.getElementById('mobile-search-drawer-input');

  if (mobileSearchToggle && mobileSearchInput) {
    mobileSearchToggle.addEventListener('change', function() {
      if (this.checked) {
        // Drawer is geopend - focus op input
        setTimeout(() => {
          mobileSearchInput.focus();
        }, 300); // Wacht tot animatie klaar is
      } else {
        // Drawer is gesloten - clear input
        mobileSearchInput.value = '';
        // Clear results
        const resultsContent = document.querySelector('.mobile-predictive-search-content');
        if (resultsContent) {
          resultsContent.innerHTML = '';
        }
      }
    });
  }
});

// ==================================================
// MOBILE PREDICTIVE SEARCH CLASS
// ==================================================

class MobilePredictiveSearch {
  constructor() {
    this.searchInput = document.getElementById('mobile-search-drawer-input');
    this.resultsContainer = document.getElementById('mobile-predictive-search-results');
    this.resultsContent = this.resultsContainer?.querySelector('.mobile-predictive-search-content');
    this.statusElement = this.resultsContainer?.querySelector('.mobile-predictive-search-status');

    this.minCharacters = 2;
    this.debounceTimer = null;
    this.debounceDelay = 300;
    this.currentQuery = '';
    this.abortController = null;
    this.storageKey = 'ir_search_history';
    this.viewHistoryKey = 'ir_view_history';
    this.maxHistoryItems = 5;
    this.maxViewHistory = 10;

    if (!this.searchInput || !this.resultsContainer) {
      console.warn('Mobile search elements niet gevonden');
      return;
    }

    this.init();
  }

  init() {
    // Input event listener
    this.searchInput.addEventListener('input', (e) => {
      this.handleInput(e.target.value);
    });

    // Focus event - toon suggesties of zoekgeschiedenis
    this.searchInput.addEventListener('focus', () => {
      if (this.currentQuery.length >= this.minCharacters) {
        this.showResults();
      } else {
        // Toon recente zoekopdrachten als er geen query is
        this.showSearchHistory();
      }
    });

    // Form submit - sla zoekopdracht op
    const form = this.searchInput.closest('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        const query = this.searchInput.value.trim();
        if (query.length > 0) {
          this.saveSearchQuery(query);
        }
      });
    }
  }

  saveSearchQuery(query) {
    try {
      let history = this.getSearchHistory();

      // Verwijder duplicaten (case insensitive)
      history = history.filter(item => item.toLowerCase() !== query.toLowerCase());

      // Voeg nieuwe query toe aan het begin
      history.unshift(query);

      // Limiteer tot max items
      history = history.slice(0, this.maxHistoryItems);

      // Sla op in localStorage
      localStorage.setItem(this.storageKey, JSON.stringify(history));
    } catch (error) {
      console.warn('Kon zoekgeschiedenis niet opslaan:', error);
    }
  }

  getSearchHistory() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.warn('Kon zoekgeschiedenis niet ophalen:', error);
      return [];
    }
  }

  getViewHistory() {
    try {
      const stored = localStorage.getItem(this.viewHistoryKey);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      return [];
    }
  }

  generateSmartSuggestions() {
    const viewHistory = this.getViewHistory();

    if (viewHistory.length === 0) {
      return [];
    }

    const suggestions = new Set();
    const categoryCount = {};
    const vendorCount = {};

    // Analyseer bekeken producten
    viewHistory.forEach(item => {
      // Tel categorieën
      if (item.type) {
        categoryCount[item.type] = (categoryCount[item.type] || 0) + 1;
      }

      // Tel vendors/merken
      if (item.vendor) {
        vendorCount[item.vendor] = (vendorCount[item.vendor] || 0) + 1;
      }

      // Extract keywords uit titel (woorden > 3 letters)
      if (item.title) {
        const words = item.title.toLowerCase().split(/\s+/);
        words.forEach(word => {
          const clean = word.replace(/[^\w]/g, '');
          if (clean.length > 3 && !this.isCommonWord(clean)) {
            suggestions.add(clean);
          }
        });
      }
    });

    // Top categorieën toevoegen
    const topCategories = Object.entries(categoryCount)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 2)
      .map(([cat]) => cat.toLowerCase());
    topCategories.forEach(cat => suggestions.add(cat));

    // Top vendors toevoegen
    const topVendors = Object.entries(vendorCount)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 1)
      .map(([vendor]) => vendor.toLowerCase());
    topVendors.forEach(vendor => suggestions.add(vendor));

    // Converteer naar array, limiteer tot 3
    return Array.from(suggestions).slice(0, 3);
  }

  isCommonWord(word) {
    const common = ['voor', 'met', 'van', 'een', 'het', 'the', 'and', 'with', 'for', 'from'];
    return common.includes(word);
  }

  showSearchHistory() {
    const history = this.getSearchHistory();
    const smartSuggestions = this.generateSmartSuggestions();

    // Als er geen geschiedenis is EN geen slimme suggesties
    if (history.length === 0 && smartSuggestions.length === 0) {
      this.hideResults();
      return;
    }

    let html = '';

    // Toon recente zoekopdrachten
    if (history.length > 0) {
      const recentSearches = history.slice(0, 3);

      html += `
        <div class="mobile-search-history">
          <div class="mobile-search-history-header">
            <h4>Recente zoekopdrachten</h4>
          </div>
          <div class="mobile-search-history-list">
      `;

      recentSearches.forEach((query) => {
        html += `
          <a href="/search?q=${encodeURIComponent(query)}" class="mobile-search-history-item" data-query="${this.escapeHtml(query)}">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M12 21a9 9 0 100-18 9 9 0 000 18z" stroke="currentColor" stroke-width="2"/>
              <path d="M12 8v5l3 3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <span>${this.escapeHtml(query)}</span>
          </a>
        `;
      });

      html += `
          </div>
        </div>
      `;
    }

    // Toon slimme suggesties op basis van bekeken producten
    if (smartSuggestions.length > 0) {
      html += `
        <div class="mobile-search-suggestions">
          <div class="mobile-search-suggestions-header">
            <h4>Zoek op basis van wat je bekeken hebt</h4>
          </div>
          <div class="mobile-search-suggestions-list">
      `;

      smartSuggestions.forEach((suggestion) => {
        html += `
          <a href="/search?q=${encodeURIComponent(suggestion)}" class="mobile-search-suggestion-item" data-query="${this.escapeHtml(suggestion)}">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M13 10V3L4 14h7v7l9-11h-7z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>${this.escapeHtml(suggestion)}</span>
          </a>
        `;
      });

      html += `
          </div>
        </div>
      `;
    }

    this.resultsContent.innerHTML = html;
    this.showResults();

    // Event listeners
    this.resultsContent.querySelectorAll('.mobile-search-history-item, .mobile-search-suggestion-item').forEach(item => {
      item.addEventListener('click', (e) => {
        const query = e.currentTarget.dataset.query;
        this.searchInput.value = query;
        this.saveSearchQuery(query);
      });
    });
  }

  handleInput(value) {
    const query = value.trim();

    clearTimeout(this.debounceTimer);

    if (this.abortController) {
      this.abortController.abort();
    }

    if (query.length < this.minCharacters) {
      this.hideResults();
      this.currentQuery = '';
      return;
    }

    if (query === this.currentQuery) {
      return;
    }

    this.currentQuery = query;
    this.showLoading();

    this.debounceTimer = setTimeout(() => {
      this.performSearch(query);
    }, this.debounceDelay);
  }

  async performSearch(query) {
    try {
      this.abortController = new AbortController();

      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag`;

      const response = await fetch(url, {
        signal: this.abortController.signal
      });

      if (!response.ok) {
        throw new Error(`Search failed: ${response.status}`);
      }

      const data = await response.json();
      this.renderResults(data, query);

    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }
      console.error('Mobile search error:', error);
      this.showError();
    }
  }

  renderResults(data, query) {
    let products = data.resources?.results?.products || [];

    if (products.length === 0) {
      this.renderEmptyState(query);
      return;
    }

    products = products.slice(0, 5);

    let html = '<div class="mobile-search-results-list">';

    products.forEach((product) => {
      const price = this.formatPrice(product.price);
      const imageUrl = product.image || '';

      html += `
        <a href="${product.url}" class="mobile-search-result-item">
          <div class="mobile-search-result-image">
            ${imageUrl ? `
              <img src="${imageUrl}" alt="${this.escapeHtml(product.title)}" loading="lazy">
            ` : `
              <div class="mobile-search-result-placeholder">
                <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
                  <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
                  <path d="M21 15l-5-5L5 21" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
            `}
          </div>
          <div class="mobile-search-result-info">
            <h4>${this.highlightQuery(product.title, query)}</h4>
            <div class="mobile-search-result-price">${price}</div>
          </div>
        </a>
      `;
    });

    html += '</div>';

    this.resultsContent.innerHTML = html;
    this.showResults();
  }

  renderEmptyState(query) {
    this.resultsContent.innerHTML = `
      <div class="mobile-search-empty">
        <p>Geen resultaten gevonden voor "${this.escapeHtml(query)}"</p>
      </div>
    `;
    this.showResults();
  }

  showLoading() {
    this.resultsContent.innerHTML = `
      <div class="mobile-search-loading">
        <p>Zoeken...</p>
      </div>
    `;
    this.showResults();
  }

  showError() {
    this.resultsContent.innerHTML = `
      <div class="mobile-search-empty">
        <p>Er is iets misgegaan. Probeer het opnieuw.</p>
      </div>
    `;
    this.showResults();
  }

  showResults() {
    // Results container is altijd zichtbaar in de drawer
    if (this.resultsContent) {
      this.resultsContent.style.display = 'block';
    }
  }

  hideResults() {
    // Clear de content maar verberg de container niet
    if (this.resultsContent) {
      this.resultsContent.innerHTML = '';
    }
  }

  formatPrice(price) {
    let priceNum = typeof price === 'string' ? parseFloat(price) : price;
    priceNum = priceNum > 1000 ? priceNum / 100 : priceNum;
    return `€${priceNum.toFixed(2)}`.replace('.', ',');
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  highlightQuery(text, query) {
    const escaped = this.escapeHtml(text);
    const regex = new RegExp(`(${query})`, 'gi');
    return escaped.replace(regex, '<mark>$1</mark>');
  }
}

// Initialize Mobile Predictive Search
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MobilePredictiveSearch();
  });
} else {
  new MobilePredictiveSearch();
}

// ==================================================
// PRODUCT VIEW TRACKER
// ==================================================

(function() {
  // Check of we op een product pagina zijn
  if (window.location.pathname.includes('/products/')) {
    try {
      // Haal product data op uit de pagina (Shopify injects deze vaak)
      const productData = window.ShopifyAnalytics?.meta?.product;

      if (productData) {
        // Get main image from page
        const productImage = document.querySelector('meta[property="og:image"]')?.content ||
                           document.querySelector('.product-main-image img')?.src ||
                           document.querySelector('.product-image img')?.src;

        // Get all product images from gallery/slider
        const images = [];
        const imageElements = document.querySelectorAll('.product-image-item img, .product-image-scroll img, .product-gallery img, [data-product-media] img');
        imageElements.forEach(img => {
          if (img.src && !img.src.includes('placeholder') && !img.src.includes('thumbnail') && !images.includes(img.src)) {
            images.push(img.src);
          }
        });

        themeLog('Product view tracking - found', images.length, 'images');

        // Fallback: use main image if no gallery images found
        if (images.length === 0 && productImage) {
          images.push(productImage);
          themeLog('Product view tracking - using fallback image');
        }

        // Get price from Shopify Analytics or page element
        let price = null;
        if (productData.price) {
          price = productData.price;
        } else {
          const priceElement = document.querySelector('#product-price') ||
                             document.querySelector('[data-product-price]') ||
                             document.querySelector('.price');
          if (priceElement) {
            const priceText = priceElement.textContent.trim();
            const priceMatch = priceText.match(/[\d.,]+/);
            if (priceMatch) {
              price = Math.round(parseFloat(priceMatch[0].replace(',', '.')) * 100);
            }
          }
        }

        // Sla product view op
        saveProductView({
          id: productData.id,
          title: productData.title || document.title.split('|')[0].trim(),
          type: productData.type,
          vendor: productData.vendor,
          url: window.location.pathname,
          image: productImage,
          images: images.slice(0, 8), // Max 8 images for performance
          price: price,
          timestamp: Date.now()
        });
      } else {
        // Fallback: haal data uit meta tags
        const title = document.querySelector('meta[property="og:title"]')?.content ||
                     document.querySelector('h1')?.textContent?.trim();

        const productImage = document.querySelector('meta[property="og:image"]')?.content;

        // Get all product images from gallery/slider
        const images = [];
        const imageElements = document.querySelectorAll('.product-image-item img, .product-image-scroll img, .product-gallery img, [data-product-media] img');
        imageElements.forEach(img => {
          if (img.src && !img.src.includes('placeholder') && !img.src.includes('thumbnail') && !images.includes(img.src)) {
            images.push(img.src);
          }
        });

        themeLog('Product view tracking - found', images.length, 'images');

        // Fallback: use main image if no gallery images found
        if (images.length === 0 && productImage) {
          images.push(productImage);
          themeLog('Product view tracking - using fallback image');
        }

        let price = null;
        const priceElement = document.querySelector('#product-price') ||
                           document.querySelector('[data-product-price]') ||
                           document.querySelector('.price');
        if (priceElement) {
          const priceText = priceElement.textContent.trim();
          const priceMatch = priceText.match(/[\d.,]+/);
          if (priceMatch) {
            price = Math.round(parseFloat(priceMatch[0].replace(',', '.')) * 100);
          }
        }

        // Status en prijs liever uit het JSON-blok dan uit de DOM: bij een
        // uit-assortimentproduct staat de prijs niet meer op de pagina.
        let available = true;
        let uitAssortiment = false;
        const statusEl = document.querySelector('[data-product-status]');
        if (statusEl) {
          try {
            const status = JSON.parse(statusEl.textContent);
            available = status.available !== false;
            uitAssortiment = status.uit_assortiment === true;
            if (status.price) price = status.price;
          } catch (e) {
            themeLog('Kon productstatus niet lezen:', e);
          }
        }

        if (title) {
          saveProductView({
            id: window.location.pathname,
            title: title,
            type: document.querySelector('meta[property="product:category"]')?.content || '',
            vendor: document.querySelector('meta[property="product:brand"]')?.content || '',
            url: window.location.pathname,
            image: productImage,
            images: images.slice(0, 8), // Max 8 images for performance
            price: price,
            available: available,
            uitAssortiment: uitAssortiment,
            timestamp: Date.now()
          });
        }
      }
    } catch (error) {
      console.warn('Product view tracking error:', error);
    }
  }

  function saveProductView(product) {
    try {
      const storageKey = 'ir_view_history';
      const maxItems = 10;

      let history = [];
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        history = JSON.parse(stored);
      }

      // Verwijder oude versie van hetzelfde product
      history = history.filter(item => item.id !== product.id);

      // Voeg nieuwe view toe aan het begin
      history.unshift(product);

      // Limiteer tot max items
      history = history.slice(0, maxItems);

      // Sla op
      localStorage.setItem(storageKey, JSON.stringify(history));
    } catch (error) {
      console.warn('Could not save product view:', error);
    }
  }
})();
